import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aprende',
  templateUrl: './aprende.component.html',
  styleUrls: ['./aprende.component.scss']
})
export class AprendeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      window.open('https://triidy.mykajabi.com/offers/hrzq8oFM', '_blank');
    }, 3000);
    setTimeout(() => {
      window.location.pathname = '/';
    }, 4000);
  }

}
